import { z } from 'zod';
import { ExpertServiceSchema, ExpertPartnerSchema, ExpertLocationSchema, ExpertRepresentativeSchema } from './expert-details';
import { ExpertCustomerStoryCardSchema } from './customer-story-card';
import { LanguageLabelTransformer } from '../transformers/language.transformers';
import { AgencyTypeFieldsSchema, AgencyTypeSchema, AppTierSchema, ListingTypeSchema, ShopifyPartnerTierSchema } from './shared';

// Expert card details schema for listing view (subset of full details)
// TODO: Make `id` required once the backend API includes it in the response
// Backend endpoints that need to return `id`:
// - GET /experts-profile-listing
// - GET /experts-profile-listing/by-slugs
export const ExpertCardDetailsSchema = z.object({
    id: z.number().optional(),
    avatar: z.string().optional().nullable().default('').transform((val) => val || undefined),
    name: z.string().optional().nullable().default('').transform((val) => val || ''),
    type: z.enum(['freelancer', 'agency']),
    listing_type: ListingTypeSchema.optional(),
    agency_type: AgencyTypeSchema.optional(),
    agency_type_fields: AgencyTypeFieldsSchema.optional(),
    partnerTier: ShopifyPartnerTierSchema.nullable().optional().default('none'),
    appTier: AppTierSchema.optional(),
    title: z.string().optional().nullable().transform((val) => val || undefined),
    description: z.string().optional().nullable().transform((val) => val || undefined),
    slug: z.string().optional().default('').transform((val) => val || ''),
    isPro: z.boolean(),
    price: z.number().default(0),
    overallReviewAverage: z.number().optional().default(0),
    overallReviewsCount: z.number().optional().default(0),
    // Mirrors PublicExpertListingCardSchema.confidence_score; optional so the
    // client tolerates the field's rollout window on these endpoints.
    confidence_score: z.object({
        score: z.number().min(0).max(100),
        earned_points: z.number().nonnegative(),
        available_points: z.number().nonnegative(),
    }).optional(),
    services: z.array(ExpertServiceSchema).optional().nullable().default([]).transform((val) => val || []),
    partners: z.array(ExpertPartnerSchema).optional().nullable().default([]).transform((val) => val || []),
    customerStories: z.array(ExpertCustomerStoryCardSchema).optional().nullable().default([]).transform((val) => val || []),
    location: ExpertLocationSchema,
    languages: z.array(z.string()).optional().default([]).transform((val) => val.map(LanguageLabelTransformer)),
    representative: ExpertRepresentativeSchema.nullable().optional().transform((val) => val || undefined),
});

export type ShopexpertsExpertCardDetails = z.infer<typeof ExpertCardDetailsSchema>;

